import { render } from "./UrohancerPage.vue?vue&type=template&id=e940c1a0"
import script from "./UrohancerPage.vue?vue&type=script&lang=js"
export * from "./UrohancerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__